import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../config";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ReactComponent as SearchIcon } from "../assets/svg/search-lg.svg";
import { getListingData } from "../services/api";
import { setMapCenter, setMapZoom } from "../store/reducers/listingReducer";

interface IProps {}

export const Search = (props: IProps) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const logged = useSelector((state: any) => state.listingReducer.logged);
  const [suggestions, setSuggestions] = React.useState<string[]>([]);
  const [inputValue, setInputValue] = React.useState<string>("");
  const [selectedIndex, setSelectedIndex] = React.useState<number>(-1);
  const [hideSuggestions, setHideSuggestions] = React.useState<boolean>(true);
  const inputRef = React.useRef<any>(null); // Ref for the input element
  const searchContainerRef = React.useRef<any>();
  const listings = useSelector((state: any) => state.listingReducer.listings);
  const mapCenter = useSelector((state: any) => state.listingReducer.mapCenter);
  const mapZoom = useSelector((state: any) => state.listingReducer.mapZoom);

  React.useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (inputValue) {
        handleInputChange(inputValue);
      }
    }, 300); // 300ms delay

    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event?.target as Node)
      ) {
        setHideSuggestions(true);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchContainerRef]);

  const handleInputChange = async (value: string) => {
    setHideSuggestions(false);
    const trimmedValue = value.trim();
    const isLastCharSpace =
      trimmedValue.length > 0 && value[value.length - 1] === " ";
    setSuggestions([]);
    let returnListings = await getListingData("", mapCenter, mapZoom, value);
    setSuggestions(returnListings.data.data);
  };

  const handleSuggestionClick = (suggestion: any, type?: string) => {
    setInputValue(suggestion.address);
    dispatch(
      setMapCenter({
        lat: suggestion.latitude,
        lng: suggestion.longitude,
        search: true,
      })
    );
    dispatch(setMapZoom(16));
    navigate(config.path + suggestion.listing_unique_id);
    setSuggestions([]);
    setSelectedIndex(-1);
    if (inputRef.current) {
      inputRef.current.focus(); // Refocus on the input field
    }
  };

  const handleKeyDown = (e: { key: string; preventDefault: () => void }) => {
    if (e.key === "ArrowDown" && suggestions.length > 0) {
      e.preventDefault();
      setSelectedIndex((prevIndex) => (prevIndex + 1) % suggestions.length);
    }
  };

  const handleEnter = (e: { key: string; preventDefault: () => void }) => {
    if (e.key === "Enter" && selectedIndex >= 0) {
      e.preventDefault();
      //setLastSuggestion('');
      handleSuggestionClick(
        suggestions[selectedIndex],
        suggestions[selectedIndex]
      );
    }
  };

  return (
    <div className="relative flex gap-x-3">
      <div ref={searchContainerRef} className="relative h-11 w-[22.1rem]">
        <input
          type="text"
          name="search"
          placeholder="Address, City, Zip or Neighborhood"
          className="py-3 px-4 text-gray-500 border w-full outline-none"
          value={inputValue}
          onClick={() => (inputValue ? setHideSuggestions(false) : "")}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => {
            handleKeyDown(e);
            handleEnter(e);
          }}
        />
        {!hideSuggestions ? (
          <div className="absolute w-full z-30">
            <ul className="bg-white shadow-md">
              {suggestions.map((suggestion: any, index: number) => (
                <li key={"suggestion_" + index} className="p-4">
                  <button
                    className="font-medium"
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    <span className="line-clamp-1">
                      {suggestion.name !== "Not available"
                        ? suggestion.name
                        : ""}{" "}
                      {suggestion.secondary_name
                        ? " (" + suggestion.secondary_name + ")"
                        : ""}{" "}
                      {" - " + suggestion.address}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
      <span className="absolute top-3 right-3">
        <SearchIcon />
      </span>
      {/* <button className="bg-primary px-4 py-3 text-white font-medium hidden md:block">
        Search
      </button> */}
    </div>
  );
  // return (
  //     <div ref={searchContainerRef} className={"search-container"}>
  //         <div
  //             className={(suggestions.length > 0 && !hideSuggestions) ? 'show-suggestion search-wrapper' : 'search-wrapper'}>
  //             <div className="search">
  //                 <i className="fa fa-search"></i>
  //                 <input type="text" className="form-control" placeholder="Enter your search"
  //                        value={inputValue}
  //                        onClick={() => inputValue ? setHideSuggestions(false): ''}
  //                        onChange={(e) => setInputValue(e.target.value)}
  //                        onKeyDown={(e) => {
  //                            handleKeyDown(e);
  //                            handleEnter(e);
  //                        }}
  //                        ref={inputRef}/>
  //                 <span className="fa fa-search"></span>
  //             </div>
  //             <div className="search-suggestion-box">
  //                 <ul>
  //                     {suggestions.map((suggestion: any, index: number) => (
  //                         <li key={'suggestion_' + index} className={index === selectedIndex ? 'selected' : ''}>
  //                             <a
  //                                 href="#"
  //                                 onClick={() => handleSuggestionClick(suggestion)}>{suggestion.name !== 'Not available' ? suggestion.name : ''} {suggestion.secondary_name !== '' ? ' (' + suggestion.secondary_name + ')' : ''} {' - ' + suggestion.address}</a>
  //                         </li>
  //                     ))}
  //                 </ul>
  //             </div>
  //         </div>
  //     </div>

  // );
};
export default Search;
